import { Component, effect, inject, signal } from '@angular/core';
import { AnalyticsService, WidgetData } from '../../../../../core/services/analytics.service';
import { BaseComponent } from '../../../../../core/shared/common/base.component';
import { filter, switchMap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MetricCardComponent } from '../../../../../core/components/metric-card/metric-card.component';
import { CommonModule } from '@angular/common';
import { getThisWeekDateRange } from '../../../../../core/shared/common/date-range.util';

@Component({
  selector: 'app-closed-today-widget',
  standalone: true,
  imports: [MetricCardComponent, CommonModule],
  templateUrl: './closed-today-widget.component.html',
  styleUrl: './closed-today-widget.component.scss',
  providers: [AnalyticsService],
})
export class ClosedTodayWidgetComponent extends BaseComponent {
  private route = inject(ActivatedRoute);
  private analyticsService = inject(AnalyticsService);

  public closedTodayTicketData = signal<WidgetData>({ value: 0, colors: [] });
  public isLoading = signal<boolean>(true);

  // For the metric card
  public cardTitle = 'Closed';

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(() => {
      this.route.queryParams
        .pipe(
          filter((params) => {
            return !!params['organizationId'];
          }),
          switchMap((params) => {
            const dateRange = getThisWeekDateRange();
            return this.analyticsService.getClosedTodayTickets(params['organizationId'], dateRange);
          })
        )
        .subscribe({
          next: (data) => {
            this.closedTodayTicketData.set(data);
            this.isLoading.set(false);
          },
          error: (error) => {
            console.error(error);
            this.isLoading.set(false);
          },
        });
    });
  }
}
